import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/login");
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      try {
        await api.post("/auth/session", { session_id });
        await refresh();
        // Check whether user needs to accept the current consent version
        let target = "/browse";
        try {
          const c = await api.get("/me/consent");
          if (c.data?.needs_consent) target = "/consent";
        } catch {}
        window.history.replaceState(null, "", target);
        nav(target, { replace: true });
      } catch {
        nav("/login");
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="pbp-section py-24 text-center text-[#86868b]">
      Signing you in…
    </div>
  );
}
